import { useLayoutEffect } from 'react';

/**
 * Custom hook for positioning a portal element
 * @param {React.RefObject} portalRef - Ref to the portal element
 * @param {Object} position - Position configuration
 * @param {string|number} position.top - Top position (CSS value)
 * @param {string|number} position.left - Left position (CSS value)
 * @param {string|number} position.zIndex - Z-index value
 * @param {string|number} position.height - Height (CSS value)
 * @param {boolean} isActive - Whether positioning should be active
 */
export const usePortalPositioning = (portalRef, position, isActive = true) => {
    useLayoutEffect(() => {
        if (!isActive || !portalRef.current) return;

        const element = portalRef.current;
        const { top, left, zIndex, height, ...otherStyles } = position;

        // Apply positioning styles
        if (top !== undefined) {
            element.style.top = typeof top === 'number' ? `${top}px` : top;
        }
        if (left !== undefined) {
            element.style.left = typeof left === 'number' ? `${left}px` : left;
        }
        if (zIndex !== undefined) {
            element.style.zIndex = zIndex.toString();
        }
        if (height !== undefined) {
            element.style.height = typeof height === 'number' ? `${height}px` : height;
        }

        // Apply any other styles
        Object.entries(otherStyles).forEach(([key, value]) => {
            if (value !== undefined) {
                element.style[key] = typeof value === 'number' ? `${value}px` : value;
            }
        });
    }, [portalRef, position, isActive]);
};
